var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconSuccessCheck = function SvgIconSuccessCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.333008C5.56004 0.333008 0.333374 5.55967 0.333374 11.9997C0.333374 18.4397 5.56004 23.6663 12 23.6663C18.44 23.6663 23.6667 18.4397 23.6667 11.9997C23.6667 5.55967 18.44 0.333008 12 0.333008ZM8.83837 17.0047L4.65004 12.8163C4.19504 12.3613 4.19504 11.6263 4.65004 11.1713C5.10504 10.7163 5.84004 10.7163 6.29504 11.1713L9.66671 14.5313L17.6934 6.50467C18.1484 6.04967 18.8834 6.04967 19.3384 6.50467C19.7934 6.95967 19.7934 7.69467 19.3384 8.14967L10.4834 17.0047C10.04 17.4597 9.29338 17.4597 8.83837 17.0047Z",
    fill: "#6FCF97"
  })));
};

export default __webpack_public_path__ + "static/media/IconSuccessCheck.41f6963e.svg";
export { SvgIconSuccessCheck as ReactComponent };